import { EmailPasswordPhoneEntry } from "./email-password-phone-entry";
import { SignUpAuthProvider } from "./sign-up-auth";
import { SignUpGoogleOption, SignUpSteps } from "./sign-up-steps";

export { GoogleSignUpContinuation } from "./google-sign-up-continuation";
export { useSignUpAuth } from "./sign-up-auth";
export type {
  GoogleSignUpEntry,
  SignUpAuthProviderProps,
} from "./sign-up-auth";
export { useGoogleSignUpContinuation } from "./use-google-sign-up-continuation";
export type { PendingGoogleSignUp } from "./use-google-sign-up-continuation";

/**
 * Portal sign-up funnel, as composable parts. Every part reads the funnel
 * state from `PortalSignUp.Provider` and renders only on the step it owns:
 *
 * ```tsx
 * <PortalSignUp.Provider>
 *   <AuthFlow.Phone className="p-0">
 *     <AuthFlow.Header showOnlyWhilePhoneStep={PhoneAuthStep.ENTER_PHONE} … />
 *     <PortalSignUp.EntryForm />
 *     <PortalSignUp.GoogleOption />
 *     <PortalSignUp.Steps />
 *   </AuthFlow.Phone>
 * </PortalSignUp.Provider>
 * ```
 *
 * Surfaces that already hold a Google credential (the portal login page
 * continuing an unlinked Google sign-in) pass it to the provider and leave
 * `GoogleOption` out.
 */
export const PortalSignUp = {
  Provider: SignUpAuthProvider,
  EntryForm: EmailPasswordPhoneEntry,
  GoogleOption: SignUpGoogleOption,
  Steps: SignUpSteps,
};
